const deviceDefaultCard = footerVisible => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flexGrow: 1,
  paddingTop: footerVisible ? '5px' : '10px',
});

const dropdownDefaultCard = {
  display: 'flex',
  alignItems: 'center',
};

const multiStackedChart = footerVisible => ({
  paddingBottom: footerVisible ? '0px' : '13px',
});

const customCallout = {
  padding: '15px',
  width: '200px',
  lineHeight: '1.8',
};

const date = {
  marginLeft: '8px',
};

const legendIcon = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px',
};

export const getStyles = footerVisible => ({
  deviceDefaultCard: deviceDefaultCard(footerVisible),
  dropdownDefaultCard,
  multiStackedChart: multiStackedChart(footerVisible),
  customCallout,
  legendIcon,
  date,
});
